import * as React from "react";
import { forwardRef } from "react";
const SvgActiveUnchecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 2, y: 2, width: 18, height: 18, rx: 1, stroke: "#8C9EBA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 21, height: 21, rx: 2.5, stroke: "#182231" }));
const ForwardRef = forwardRef(SvgActiveUnchecked);
export { ForwardRef as ReactComponent };
